import React from "react";
import { Link } from "react-router-dom";
import "./Footer6.css";

function Footer6() {
  return (
    <div className="footer-11">
      <div className="group-125-1">
        <div className="flex-row-14">
          <div className="flex-col-13">
            <div className="overlap-group2-5">
              <div className="group-25-3">
                <div className="contact-us-6 poppins-medium-tundora-16px">Contact Us</div>
                <div className="flex-row-15">
                  <div className="overlap-group-container-3">
                    <div className="overlap-group-13">
                      <img className="vector-18" src="/img/vector-11@2x.png" />
                    </div>
                    <div className="overlap-group1-6">
                      <img className="vector-18" src="/img/vector-11@2x.png" />
                    </div>
                  </div>
                  <div className="flex-col-14 roboto-normal-tundora-12px">
                    <p className="x123-lane-opp-sai-4">
                      123, lane, opp. Sai Temple
                      <br />
                      Emerald Hills
                      <br />
                      Dehradun- 248001
                    </p>
                    <p className="r-255-2nd-floor-4">
                      R - 255, 2nd Floor, G K- 1<br />
                      Delhi - 110048
                    </p>
                    <div className="phone-4">+91-9999963537</div>
                  </div>
                </div>
              </div>
              <img className="vector-20" src="/img/vector-8@2x.png" />
            </div>
            <div className="group-container-5">
              <img className="group-91-3" src="/img/group-91@2x.png" />
              <img className="group-92-3" src="/img/group-92@2x.png" />
              <img className="group-93-3" src="/img/group-93@2x.png" />
            </div>
          </div>
          <div className="flex-col-15">
            <div className="useful-links-3 poppins-medium-tundora-16px">Useful Links</div>
            <Link to="/home">
              <div className="place-2 roboto-normal-tundora-12px">Home</div>
            </Link>
            <Link to="/about">
              <div className="link roboto-normal-tundora-12px">About Us</div>
            </Link>
            <Link to="/services">
              <div className="link roboto-normal-tundora-12px">Services</div>
            </Link>
            <Link to="/media-publications">
              <div className="link roboto-normal-tundora-12px">Media</div>
            </Link>
            <div className="blog-8 roboto-normal-tundora-12px">Blog</div>
            <Link to="/gallery">
              <div className="link roboto-normal-tundora-12px">Gallery</div>
            </Link>
            <img className="group-94-1" src="/img/group-94@2x.png" />
          </div>
        </div>
        <div className="copyrightsohnijunejacom-5 roboto-normal-tundora-12px">copyright@sohnijuneja.com</div>
      </div>
    </div>
  );
}

export default Footer6;
